import { ReactElement, useCallback, useState } from 'react';
import { GoogleMap } from './googleMap';

interface Site {
	id: string;
	name: string;
	address: string;
	lat: number;
	lng: number;
}
interface IGoogleMapModal {
	handleConfirm?: () => void;
	handleClose?: () => void;
	onDetailedAddressChange?: (details: { longitude: string; latitude: string; pincode: string; city: string }) => void;
	isMapscreen?: boolean;
	siteList?: Site[];
}

export const GoogleMapModal = (props: IGoogleMapModal): ReactElement => {
	const { handleConfirm, handleClose, onDetailedAddressChange, isMapscreen } = props;
	const [address, setAddress] = useState<string>('');

	const handleDetailedAddress = useCallback(
		(details: { longitude: string; latitude: string; pincode: string; city: string }): void => {
			if (onDetailedAddressChange) {
				onDetailedAddressChange(details);
			}
		},

		// eslint-disable-next-line react-hooks/exhaustive-deps
		[]
	);

	return (
		<>
			<GoogleMap setAddress={setAddress} setDetailedAddress={handleDetailedAddress} siteList={props.siteList} />
			{!isMapscreen && (
				<>
					<div className="map-address">
						<span className="location-label">Location</span>
						{address && <div className="address">{address}</div>}
					</div>

					<div className="location-btn-wrapper">
						<button className="close-btn btn btn-primary" onClick={handleClose}>
							Close
						</button>
						<button className="btn btn-primary" onClick={handleConfirm}>
							Confirm
						</button>
					</div>
				</>
			)}
		</>
	);
};
